export default "__VITE_ASSET__DjPWXJ50__"